import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../../components/layout/PublicLayout';

const ActiveDeals = () => {
  const navigate = useNavigate();

  return (
    <PublicLayout title="Active Deals" showBack>
      <div className="max-w-6xl mx-auto">
        <div className="card">
          <h2 className="outfit font-bold text-xl mb-4">Available Deals</h2>
          <p className="text-sm mb-6" style={{ color: 'var(--text-muted)' }}>
            Active deals page - To be implemented with product listings and deal sharing
          </p>
          <button
            onClick={() => navigate('/')}
            className="btn btn-secondary"
          >
            Back to Home
          </button>
        </div>
      </div>
    </PublicLayout>
  );
};

export default ActiveDeals;
